import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Customer } from "../../models/customer.model";

import { CustomerService } from "../../services/customer.service";

import { DialogCustomerComponent } from "../dialog-customer/dialog-customer.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Person } from "../../models/person.model";
import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { Catalog } from "../../models/product.model";
import { CatalogService } from "../../services/catalog.service";

@Component({
  selector: "ngx-view-customers",
  styleUrls: ["./view-customers.component.scss"],
  templateUrl: "./view-customers.component.html",
})
export class ViewCustomersComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //customers / receipt / loan
  @Input() shopId?: string = "";
  @Output() onSelectedCustomer: EventEmitter<any> = new EventEmitter();

  display?: Customer[] = [];
  customer: Customer = new Customer();
  users?: Person[];
  productCategories?: Catalog[];

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  strSearch = "";
  uid = "anonymous";
  user?: User;
  companyId = "anonymous";
  @ViewChild("title") title: ElementRef;
  @ViewChild("mobile") mobile: ElementRef;
  isMoreInfo = true;

  page: number = 1;
  itemsPerPage: number = 10;
  indexSelected: number = 0;

  constructor(
    private userService: UserService,
    private customerService: CustomerService,
    private catalogService: CatalogService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.companyId = user.companyId;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
          this.companyId = "anonymous";
        }

        this.getUsers();
        this.getCatalogs();
      });

    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [
      Validators.minLength(9),
      Validators.maxLength(11),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();

      this.search();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Quick create customer
  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputMobile() {
    if (this.isMoreInfo) {
      this.mobile.nativeElement.focus();
    }
  }

  //load data
  //Users
  getUsers() {
    this.loading = true;
    this.userService
      .getUsers(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.users = [];
        _.forEach(data, (item) => {
          let cus: Person = new Person();
          cus.id = item.id;
          cus.fullName = item.displayName;
          cus.mobile = "";
          cus.email = item.email;
          cus.address = "";
          this.users.push(cus);
        });

        this.loading = false;
      });
  }

  private getCatalogs(): void {
    this.loading = true;

    this.catalogService
      .getCatalogsByMode(this.shopId, "categories")
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          console.log("getCatalogs/productCategories:", data);
          this.productCategories = _.sortBy(data, ["title"]);
          this.loading = false;
        },
        (error) => {
          this.productCategories = [];
          this.loading = false;
        }
      );
  }

  create() {
    this.customer.shopId = this.shopId;
    this.customer.fullName = this.customer.fullName
      ? this.customer.fullName.trim()
      : "";
    this.customer.mobile = this.customer.mobile
      ? this.customer.mobile.trim()
      : "";

    if (this.customer.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.customerService
        .create(this.customer)
        .then((data) => {
          this.customer = new Customer();
          this.title.nativeElement.focus();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  edit(item: Customer) {
    let lecBk = new Customer();
    lecBk = clone(item);
    this.dialogService
      .open(DialogCustomerComponent, {
        context: {
          header: "Cập nhật khách hàng",
          mode: "edit",
          shopId: this.shopId,
          user: this.user,
          customer: lecBk,
          users: this.users,
          productCategories: this.productCategories,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          console.log(
            "🚀 ~ file: view-customers.component.ts:265 ~ .onClose.subscribe ~ item:",
            item
          );
          if (item.isDeleted) {
            this.onDelete(item.id);
          } else {
            this.onEdit(item);
          }
        }
      });
  }

  onNew() {
    let lecNew = new Customer();
    lecNew.dob = new Date();
    lecNew.gender = "Khác";
    this.dialogService
      .open(DialogCustomerComponent, {
        context: {
          header: "Tạo khách hàng",
          mode: "new",
          shopId: this.shopId,
          user: this.user,
          customer: lecNew,
          users: this.users,
          productCategories: this.productCategories,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.customer = new Customer();
        }
      });
  }

  onEdit(item: Customer) {
    if (item) {
      for (let i = 0; i < this.display.length; i++) {
        if (this.display[i].id == item.id) {
          this.display[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    _.remove(this.display, (e) => {
      return e.id == value;
    });
  }

  search() {
    this.display = [];
    this.indexSelected = 0;
    this.page = 1;

    const strSearch = this.title.nativeElement.value
      ? this.title.nativeElement.value.toLowerCase()
      : "";

    if (strSearch === "") {
      this.display = _.clone(this.customerService.customers);
    } else {
      this.display = _.filter(this.customerService.customers, function (item) {
        const fullName = item.fullName ? item.fullName.toLowerCase() : "";
        const cardId = item.cardId ? item.cardId.toLowerCase() : "";
        const mobile = item.mobile ? item.mobile.toLowerCase() : "";
        return (
          (fullName && fullName.includes(strSearch)) ||
          (cardId && cardId.includes(strSearch)) ||
          (mobile && mobile.includes(strSearch))
        );
      });
    }
  }

  //Control event
  selected(item: Customer): void {
    this.onSelectedCustomer.emit(item);

    this.title.nativeElement.focus();
  }

  pageChange(page: number) {
    this.page = page;
    this.indexSelected = 0;
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
